import { Box, DialogActions, styled } from '@mui/material';
import React from 'react';
import { ModalActionsProps } from '../components.types';

const ModalActions = ({ children, disableShadow }: ModalActionsProps) => {
  const StyledModalActions = styled(DialogActions)(({ theme }) => ({
    '&': {
      paddingTop: 0,
      ...(!disableShadow && { boxShadow: '0px -24px 28px 25px #fff', zIndex: 1 }),
    },
  }));
  return (
    <StyledModalActions>
      <Box display="flex" gap={3} width="100%">
        {children}
      </Box>
    </StyledModalActions>
  );
};

export default ModalActions;
